import { useEffect, useRef } from 'react';

export default function useEffectOnce (cb, condition = true) {
  const hasCalled = useRef(false);

  useEffect(() => {
    if (condition && !hasCalled.current) {
      hasCalled.current = true;
      cb();
    }
  }, [cb, condition]);
}
